<template lang="html">
  <div
    @click="$emit('open', $event)"
    class="addProject"
    :class="{dark: darkmode}"
  >
    <svg width="49%" height="49%" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="26" width="8" height="60" fill="#00FF96"/>
      <rect x="60" y="26" width="8" height="60" transform="rotate(90 60 26)" fill="#00FF96"/>
    </svg>
  </div>
</template>

<script>

export default {
  props: {
    darkmode: Boolean,
  },
};
</script>

<style lang="stylus" scoped>
@require '../assets/styles/colors.styl'
@require '../assets/styles/styles.styl'

.addProject
  font-size $projectMinFontSize
  font-weight $projectMinFontWeight
  color $normal
  background-color $white
  border $borderBoxes
  border-color $normal
  box-shadow $shadow
  border-radius $radiusBoxes
  outline none
  display flex
  align-items center
  justify-content center
  &.dark
    background-color $normal
    border-color $darkmodeWhite
    box-shadow $darkmodeShadow
    color $darkmodeWhite

.addProject:after
  content ""
  display block
  padding-bottom 100%

.addProject:hover
  cursor: pointer;

</style>
